import { makeFieldValueDbModule } from '../makeFieldValueDbModule';
import { clear as constructionProductDocumentsServiceClear } from './constructionProductDocumentsService';
import { makeClearPublisher } from 'serviceWorker/broadcasts/publishers';
import { fieldValueContracts } from 'shared/domain/fieldValue/fieldValueContracts';
import { EditableFieldValuesEntityName } from 'shared/domain/fieldValue/fields';

export const {
  clear,
  quantity,
  get,
  getOne,
  addBatch,
  updateBatch,
  removeBatch,
} = makeFieldValueDbModule({
  tableName: 'constructionProductDocuments',
  serviceTableName: 'constructionProductDocumentsService',
  serviceClearFunction: constructionProductDocumentsServiceClear,
  broadcastClearFunction: makeClearPublisher(fieldValueContracts[EditableFieldValuesEntityName.constructionProductDocuments]),
});
